import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useAuth } from '@/modules/auth/hooks/useAuth';
import { getAuthenticatedDestination } from '@/modules/auth/lib/profileCompletion';

export const Route = createFileRoute('/')({
  component: IndexRedirect,
});

function IndexRedirect() {
  const { user, isAuthLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthLoading) return;
    if (user) {
      void navigate({ to: getAuthenticatedDestination(user), replace: true });
    } else {
      void navigate({ to: '/auth/login', replace: true });
    }
  }, [user, isAuthLoading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}
